export enum Dialog {
  ADD_ORGANISATION = "ADD_ORGANISATION",
  EDIT_ORGANISATION = "EDIT_ORGANISATION",
  DELETE_ORGANISATION = "DELETE_ORGANISATION",
  MERGE_ORGANISATIONS = "MERGE_ORGANISATIONS",

  ADD_USER = "ADD_USER",
  EDIT_USER = "EDIT_USER",
  DELETE_USER = "DELETE_USER",
  USER_RESET_PASSWORD = "USER_RESET_PASSWORD",

  USER_PRODUCT = "USER_PRODUCT",

  GENERATE_API_KEYS = "GENERATE_API_KEYS",
  DELETE_API_ACCOUNT_KEY = "DELETE_API_ACCOUNT_KEY",
  API_ACCOUNT_PRODUCT = "API_ACCOUNT_PRODUCT",

  ADD_LICENCE = "ADD_LICENCE",
  EDIT_LICENCE = "EDIT_LICENCE",
  DELETE_LICENCE = "DELETE_LICENCE",
  INFO_LICENCE = "INFO_LICENCE",

  ADD_LICENCE_TYPE = "ADD_LICENCE_TYPE",
  DELETE_LICENCE_TYPE = "DELETE_LICENCE_TYPE",
  EDIT_LICENCE_TYPE = "EDIT_LICENCE_TYPE",

  ADD_PRICING = "ADD_PRICING",
  EDIT_PRICING = "EDIT_PRICING",
  DELETE_PRICING = "DELETE_PRICING",
  PRICING_ADD_CURRENCY_RULES = "PRICING_ADD_CURRENCY_RULES",
  DETAILS_ORDER = "DETAILS_ORDER",
  EDIT_MULTI_CURRENCY_PRICING = "EDIT_MULTI_CURRENCY_PRICING",

  CLOSE = "CLOSE",
}

export const DialogTitle = {
  [Dialog.ADD_ORGANISATION]: "Add Organisation",
  [Dialog.EDIT_ORGANISATION]: "Edit Organisation",
  [Dialog.DELETE_ORGANISATION]: "Delete Organisation",
  [Dialog.MERGE_ORGANISATIONS]: "Merge Organisations",

  [Dialog.ADD_USER]: "Add User",
  [Dialog.EDIT_USER]: "Edit User",
  [Dialog.DELETE_USER]: "Delete User",
  [Dialog.USER_RESET_PASSWORD]: "Reset Password",

  [Dialog.USER_PRODUCT]: "User:Product",

  [Dialog.GENERATE_API_KEYS]: "Generate New API Access Token",
  [Dialog.DELETE_API_ACCOUNT_KEY]: "Delete API Access Token",
  [Dialog.API_ACCOUNT_PRODUCT]: "Api Account Products",

  [Dialog.ADD_LICENCE]: "Add Licence",
  [Dialog.EDIT_LICENCE]: "Edit Licence",
  [Dialog.DELETE_LICENCE]: "Delete Licence",

  [Dialog.DELETE_LICENCE_TYPE]: "Delete Licence Type",

  [Dialog.DELETE_PRICING]: "Delete Pricing",
  [Dialog.DETAILS_ORDER]: "Order Details",

  [Dialog.CLOSE]: "",
};
